import {loadExportConfig} from "@/store/ExportConfigStore";
import {Module} from "vuex";
import {HasRightResponse, HasRightsRequest} from "@/store/CurrencyStore";
import {AsyncJavaRequest, Main} from "@/controller/main";
import {fillDataForExport, invokeReplacementRequest, PPanelState, ppanelStore} from "@/store/PPanelStore";
import {SimpleComponentLine} from "@/store/ComponentImportStore";
import {ReplaceRequest} from "@/controller/ReplaceRequest";

interface ExportConfig {
    fileId:string,
    label: string
}

interface GlobalPPanelExportRights {
    fullPpanelFiles_ExportConfigButton_0: boolean,
    fullPpanelFiles_ExportConfigButton_1: boolean,
    fullPpanelFiles_ExportConfigButton_2: boolean,
    fullPpanelFiles_ExportConfigButton_3: boolean,
    fullPpanelFiles_ExportConfigButton_4: boolean,
    fullPpanelFiles_ExportConfigButton_5: boolean,
    fullPpanelFiles_ExportConfigButton_6: boolean,
}

class FullPpanelExportState{
    public rights: GlobalPPanelExportRights = {
        fullPpanelFiles_ExportConfigButton_0: false,
        fullPpanelFiles_ExportConfigButton_1: false,
        fullPpanelFiles_ExportConfigButton_2: false,
        fullPpanelFiles_ExportConfigButton_3: false,
        fullPpanelFiles_ExportConfigButton_4: false,
        fullPpanelFiles_ExportConfigButton_5: false,
        fullPpanelFiles_ExportConfigButton_6: false,
    };
    public fullExports:ExportConfig[] =[];
    public programs: { id: string; name: string }[] = [];
    public selectedProgram:{ id: string; name: string;project?:boolean }|null=null;
    public inProgress:number=0;
}

export class FullPpanelExportStore implements Module<any, unknown> {
    public state = new FullPpanelExportState();
    public namespaced = true;



    public getters = {
        fullExports(state: FullPpanelExportState): ExportConfig[] {
            console.log(JSON.stringify(state.fullExports));
            return state.fullExports;
        },
        programs(state:FullPpanelExportState){
            return state.programs;
        },
        selectedProgram(state:FullPpanelExportState){
            return state.selectedProgram;
        },
        inProgress(state:FullPpanelExportState):number{
            return state.inProgress;
        },
        inProgressStyle(state:FullPpanelExportState):string{
            return "width:"+state.inProgress+"%;";
        }
    }
    ;

    public mutations = {
        async download(state:FullPpanelExportState,downloadId:string){
            state.inProgress=1;
            startExport(state,downloadId).catch((e)=>{
                console.error("Error on export",e)
            });
        },

        setActiveProgram(state:FullPpanelExportState,activeProgram:{ id: string; name: string }){
            state.selectedProgram = activeProgram;
        },

        async loadFromDb(state: FullPpanelExportState) {
            const request = new HasRightsRequest();
            request.rightTags = [
                "fullPpanelFiles_ExportConfigButton_0",
                "fullPpanelFiles_ExportConfigButton_1",
                "fullPpanelFiles_ExportConfigButton_2",
                "fullPpanelFiles_ExportConfigButton_3",
                "fullPpanelFiles_ExportConfigButton_4",
                "fullPpanelFiles_ExportConfigButton_5",
                "fullPpanelFiles_ExportConfigButton_6",
            ];
            const rightResponse: HasRightResponse<GlobalPPanelExportRights> = await Main.postMessage(
                new AsyncJavaRequest("call", "hasRights", JSON.stringify(request))
            );

            state.rights = rightResponse.rights ? rightResponse.rights : {
                fullPpanelFiles_ExportConfigButton_0: false,
                fullPpanelFiles_ExportConfigButton_1: false,
                fullPpanelFiles_ExportConfigButton_2: false,
                fullPpanelFiles_ExportConfigButton_3: false,
                fullPpanelFiles_ExportConfigButton_4: false,
                fullPpanelFiles_ExportConfigButton_5: false,
                fullPpanelFiles_ExportConfigButton_6: false,
            };

            const exportConfigHead = await loadExportConfig("fullPpanelFiles");
            state.fullExports=[];
            for (let i = 0; i < exportConfigHead.labels.length; i++) {
                let label = exportConfigHead.labels[i];
                if(((<any>state.rights)["fullPpanelFiles_ExportConfigButton_"+i])) {
                    state.fullExports.push({
                        fileId: label.fileId,
                        label: label.label
                    })
                }
            }

            //programs laden
            const data = await Main.postMessage(new AsyncJavaRequest("call", "allPrograms"));
            const programs: { id: string, name: string }[] = (<any>data)["programs"];
            programs.sort((a, b) => {
                return ('' + a.name).localeCompare(b.name);
            });

            state.programs = programs;
        }
    };
}

async function startExport(state:FullPpanelExportState,downloadId:string){
    console.log("Download Requested for Program",state.selectedProgram," FileId",downloadId);
    //fetch childs
    const prefix = (state.selectedProgram?.project)?"prj":"";
    const program:SimpleComponentLine = await Main.postMessage(
        new AsyncJavaRequest("call", "allComponents",
            prefix + state.selectedProgram?.id));
    console.log("found component",program);

    //init PPanel with each child and call export

    const replaceRequest: ReplaceRequest = new ReplaceRequest();
    replaceRequest.fileId = downloadId;

    const total = program.children.length;

    for (let i = 0; i < total; i++){
        const perc = (i/total)*100;
        state.inProgress = 1+Math.ceil(perc);

        console.log("fetch child",i+"/"+total);
        let child = program.children[i];
        const aState:PPanelState = new PPanelState();
        await ppanelStore.mutations.loadFromDb(aState, child);
        console.log("StateObject",aState);

        const preparedData = fillDataForExport(aState,program);
        console.log("data for export:",preparedData)

        for (let key of Object.keys(preparedData)) {
            replaceRequest.rows=replaceRequest.rows.concat(preparedData[key]);
        }
        // await new Promise((resolve=>setTimeout(resolve,1000)));
    }

    invokeReplacementRequest(replaceRequest,()=>{
        state.inProgress=0;
    });
}


export const fullPpanelExportStore = new FullPpanelExportStore();
